import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  WALLET_SEARCH,
  WALLET_LIST_FETCH,
  WALLET_DETAIL_FETCH,
  WALLET_LIST_PROFILE_FETCH,
  WALLET_TRANSACTION_LIST_FETCH,
} from "../actions/types";
import {
  walletCountTotal,
  walletListFetchSuccess,
  walletDetailFetchSuccess,
} from "../actions";
import { showErrorMessage } from "../actions/NotifyActions";
import { authSignOutSuccess } from "../actions/AuthActions";
import {
  authorizationHeader,
  getErrorMessage_v2,
  getFilterUrl,
} from "../utils/apiUtil";
import axiosRetry from "axios-retry";

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API
export const walletListFetchRequest = async (payload = "") => {
  return await axios
    .get(`${REACT_APP_API_URL}/v1/member/all-wallet${payload}`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const walletTransactionListFetchRequest = async (payload = "") => {
  return await axios
    .get(`${REACT_APP_API_URL}/v1/member/wallet-transaction${payload}`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const walletListProfileFetchRequest = async (payload = "") => {
  return await axios
    .get(`${REACT_APP_API_URL}/v1/member/coming-wallet-expired${payload}`, {
      // v1/member/wallet-expired
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const walletDetailFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/wallets/current-points`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// WORKER

function* walletSearch({ payload }) {
  try {
    const filter = getFilterUrl(payload);
    const data = yield call(walletListFetchRequest, filter);
    yield put(walletCountTotal(data.length));
    yield put(walletListFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* walletListFetch({ payload }) {
  try {
    const data = yield call(walletListFetchRequest, payload);
    yield put(walletCountTotal(data.length));
    yield put(walletListFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* walletTransactionListFetch({ payload }) {
  try {
    const data = yield call(walletTransactionListFetchRequest, payload);
    let filterData;
    if (data.transaction && data.transaction.length > 0) {
      filterData = data.transaction.filter((transaction) => {
        return transaction.action === "plus";
      });
    }
    if (filterData) {
      yield put(walletCountTotal(filterData.length));
      yield put(walletListFetchSuccess(filterData));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage_v2(error.response)));
  }
}

function* walletDetailFetch({ payload }) {
  try {
    const data = yield call(walletDetailFetchRequest, payload);
    yield put(walletDetailFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* walletListProfileFetch({ payload }) {
  try {
    const data = yield call(walletListProfileFetchRequest, payload);
    yield put(walletCountTotal(data.length));
    yield put(walletListFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

// WATCHER
export function* walletSearchWatcher() {
  yield takeEvery(WALLET_SEARCH, walletSearch);
}

export function* walletListFetchWatcher() {
  yield takeEvery(WALLET_LIST_FETCH, walletListFetch);
}

export function* walletTransactionListFetchWatcher() {
  yield takeEvery(WALLET_TRANSACTION_LIST_FETCH, walletTransactionListFetch);
}

export function* walletListProfileFetchWatcher() {
  yield takeEvery(WALLET_LIST_PROFILE_FETCH, walletListProfileFetch);
}

export function* walletDetailFetchWatcher() {
  yield takeEvery(WALLET_DETAIL_FETCH, walletDetailFetch);
}

export default function* rootSaga() {
  yield all([
    fork(walletSearchWatcher),
    fork(walletListFetchWatcher),
    fork(walletDetailFetchWatcher),
    fork(walletListProfileFetchWatcher),
    fork(walletTransactionListFetchWatcher),
  ]);
}
